<div class="db-custom-domain-pointing-steps">
  <div class="pointing-step mb24">
    Step 1: Point domain
    @if (!step2Disabled) {
      <i class="db-icon db-icon-ds-checkmark-sharp"></i>
    }
  </div>
  <db-custom-domain-table (openNameservers)="openNameservers.emit()"
                          (removeDomain)="removeDomain.emit()"
                          (recheckStatus)="troubleshootDomaine.emit()"
                          [loading]="troubleshootDomaineLoading"
                          [domain]="domain"
                          [pointed]="pointed"
                          [status]="status"></db-custom-domain-table>
  <div class="second-step-generation" [class.disabled]="step2Disabled">
    <div class="step-header">
      <div class="pointing-step">
        Step 2: Generate a free SSL certificate to complete the setup
      </div>
      <div class="step-description">
        Generate a free SSL certificate after pointing your domain to secure client websites under your custom domain.
        Free SSL by Let’s Encrypt
      </div>
    </div>
    <div class="step-action">
      <button class="ds-btn ds-btn-black" (click)="generateSLL.emit()" [class.ds-btn-disabled]="step2Disabled">
        <span>Generate free SSL Certificate</span></button>
    </div>
  </div>
</div>
